import React from "react";

import { PageContent } from "../../components";

import { ShipmentOrdersContextProvider } from "./ShipmentOrdersContextProvider";
import ShipmentOrdersContent from "./ShipmentOrdersContent";

export const ShipmentOrdersPage = ({ defaultLocation }) => {
  return (
    <ShipmentOrdersContextProvider>
      <PageContent gap="15px" smallPadding>
        <ShipmentOrdersContent
          defaultLocation={defaultLocation}
        />
      </PageContent>
    </ShipmentOrdersContextProvider>
  );
};

export default ShipmentOrdersPage;
